import { emptyFragment } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { currentUserStore } from '../../../CurrentUserStore';
import { findLinkBy } from '../../../Links';
import ChatbotPreviewAccess from './ChatbotPreviewAccess';
import RecentActivity from './RecentActivity';
import Tasks from './Tasks';
import { fromBool } from '@execonline-inc/maybe-adapter';

function LeftSideComponents() {
  return (
    <div className="w-[33.53%]">
      {fromBool(currentUserStore.exoChatbotAccessible, true)
        .andThen(() =>
          findLinkBy({ rel: 'preview-learning-collection-template-v2' }, currentUserStore.links),
        )
        .map(() => (
          <div>
            <ChatbotPreviewAccess />
          </div>
        ))
        .getOrElse(emptyFragment)}
      <Tasks />
      <RecentActivity />
    </div>
  );
}

export default observer(LeftSideComponents);
